import axios from "axios";
import React, { useEffect, useState } from "react";
import Map from "./components/Map";
import Selector from "./components/Selector";
import Table from "./components/Table";
import getRegionCoords from "./helpers/regionCoords";

function App() {
  const [list, setList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [selectedValue, setSelectedValue] = useState("all");
  const [mapCenter, setMapCenter] = useState({
    lat: 52.805,
    lng: 19.11666,
  });
  const [zoomLevel, setZoomLevel] = useState(7);

  const fetchDistributors = async () => {
    const result = await axios.get(
      "/wp-content/themes/responsive-mobile/zestawienie_hurtowni.json"
    );

    setList(result.data.partners);
  };

  useEffect(() => {
    fetchDistributors();
  }, []);

  useEffect(() => {
    if (selectedValue === "all") {
      setZoomLevel(7);
      setFilteredList(list);
    } else {
      const updatedList = list.filter(
        (item: any) => item.wojewudztwo === selectedValue
      );

      setZoomLevel(8);
      setFilteredList(updatedList);
    }
    setMapCenter(getRegionCoords(selectedValue));
  }, [list, selectedValue]);

  return (
    <div className="App">
      <Selector handleValue={setSelectedValue} />
      <Map
        center={mapCenter}
        distributors={filteredList}
        zoomLevel={zoomLevel}
      />
      <Table distributors={filteredList} />
    </div>
  );
}

export default App;
